import _asyncToGenerator from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import Vue from 'vue';
import axios from 'axios';
import { request } from './util';

var MatchService = /*#__PURE__*/function () {
  function MatchService() {
    _classCallCheck(this, MatchService);
  }

  _createClass(MatchService, null, [{
    key: "getNbaArticleList",
    value: // 查询腾讯视频NBA以及冬奥会看点列表
    function getNbaArticleList(_ref) {
      var channelId = _ref.channelId,
          modId = _ref.modId;
      var url = 'https://access.video.qq.com/fcgi-bin/GetChannelModData';
      var params = {
        raw: 1,
        vappid: 61550642,
        vsecret: '1e70a5069a0e2388b3a0e9e94451b6d6295452c6039c475a'
      };
      var options = {
        app_id: '10014',
        app_key: 'b204e131c1e6864166ddac45e8f62c9190ca2493cfb48174ca801b199d1e7841',
        channelId: "".concat(channelId),
        modId: ["".concat(modId)],
        platform: 5
      };
      return request({
        otype: 'jsonp'
      })(url, params, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        },
        data: options,
        method: 'post'
      });
    } // 此处预约接口不能使用 rpcCgi
    // 组件中设置 content-type 为text，该接口正常输出 header无 trpc-func-ret 返回

  }, {
    key: "attent",
    value: function () {
      var _attent = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(list) {
        var url, params;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = 'https://pbaccess.video.qq.com/trpc.universal_backend_service.video_attent.AttentService/Attent';
                params = {
                  vappid: 70930403,
                  vsecret: 'ce4b714af67c9337211ea0f13264c840433a701fe83aa5eb',
                  video_appid: 1000005
                };
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  axios({
                    url: url,
                    data: {
                      attent_key: list.map(function (v) {
                        return "attent_type=4&rid=".concat(v);
                      })
                    },
                    method: 'post',
                    params: params,
                    withCredentials: true
                  }).then(function (res) {
                    if (res.status !== 200) {
                      Vue.prototype.toast('网络请求失败');
                      reject();
                    }

                    var trpcFuncRet = res.headers['trpc-func-ret'];
                    var trpcRet = res.headers['trpc-ret'];

                    if (trpcFuncRet || trpcRet) {
                      Vue.prototype.toast(res.headers['trpc-error-msg'] || '请求错误');
                      reject();
                    }

                    resolve(res.data);
                  });
                }));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function attent(_x) {
        return _attent.apply(this, arguments);
      }

      return attent;
    }()
  }]);

  return MatchService;
}();

export default MatchService;